import { ShipmentStatus } from "@/utils/enum";
import {
  acceptShipment,
  acceptManyShipments,
  assignAdminShipment,
  postAndAcceptAdminShipment,
} from "@/services/shipments_new";

export function getApiCaller(configPerm, shipmentStatus, payload) {
  if (configPerm["CoreService.AdminShipments.Accept"] && shipmentStatus === ShipmentStatus.Posted) {
    return { caller: assignAdminShipment, payload };
  }

  if (
    configPerm["CoreService.AdminShipments.Post"] &&
    configPerm["CoreService.AdminShipments.Accept"] &&
    shipmentStatus === ShipmentStatus.Completed
  ) {
    return { caller: postAndAcceptAdminShipment, payload };
  }

  if (configPerm["CoreService.AvailableLoads.Accept"] && payload.items.length === 1) {
    const { items, userId, transporterId } = payload;

    return {
      caller: acceptShipment,
      payload: { ...items[0], userId, transporterId },
    };
  }

  if (configPerm["CoreService.AvailableLoads.Accept"]) {
    return { caller: acceptManyShipments, payload };
  }
}
